import React, { useEffect, useState } from 'react'
import { GoAlert } from "react-icons/go"
import Subestacion1 from "./Subestacion1.js"
import Subestacion2 from "./Subestacion2.js"
import { Tab, Tabs } from 'react-bootstrap';
import GrafSubestacion from './GrafSubestacion.js';
import './Subestacion.css';
import { useTranslation } from 'react-i18next';

function VerSubestacion() {

    const { t } = useTranslation();
    var [subestacion, setSubestacion] = useState([]);
    var [data, setData] = useState([]);

    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if (code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/substationStatus", { method: 'GET', credentials: 'include' })
            .then(async (dataSubestacion) => { setSubestacion(await dataSubestacion.json()); })
            .catch(e => { console.log(e); })
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/substation", { method: 'GET', credentials: 'include' })
            .then(async (dataSubestacion) => { setData(await dataSubestacion.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code === sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/substationStatus", { method: 'GET', credentials: 'include' })
                    .then(async (dataSubestacion) => { setSubestacion(await dataSubestacion.json()); })
                    .catch(e => { console.log(e); })
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/substation", { method: 'GET', credentials: 'include' })
                    .then(async (dataSubestacion) => { setData(await dataSubestacion.json()); })
                    .catch(e => { console.log(e); })
            } else { //Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    //dividimos los estados de los componentes de la subestacion segun el trafo al que pertenecen
    var subestacion1 = [];
    var subestacion2 = [];
    for (let i = 0; i < subestacion.length; i++) {
        if (subestacion[i].idSet === 1) {
            subestacion1 = [...subestacion1, subestacion[i]]
        } else if (subestacion[i].idSet === 2) {
            subestacion2 = [...subestacion2, subestacion[i]]
        }
    }

    //dividimos los datos de la subestacion segun el trafo al que pertenecen
    var data1 = [];
    var data2 = [];
    for (let i = 0; i < data.length; i++) {
        if (data[i].idSet === 1) {
            data1 = [...data1, data[i]]
        } else if (data[i].idSet === 2) {
            data2 = [...data2, data[i]]
        }
    }

    if (subestacion1.length > 0) {
        var actualizados = subestacion1[0].updated;
        var fecha = subestacion1[0].timeStamp;
    }

    return (

        <div className='div-tabs-meteo'>
            <Tabs defaultActiveKey="subestacion">
                <Tab eventKey="subestacion" title={t('scada.solarFarm.substation.substation')}>
                    <div className='container'>
                        <div className='row' id="row-subestacion" style={{ maxHeight: "100vh", overflow: "auto" }}>
                            <div className='col' id='fecha-lectura' style={{ position: "absolute", top: 85, left: -50, maxWidth: "400px" }}>
                                <div className='row justify-content-center' style={{ color: "black", fontWeight: "bold", fontSize: "13px" }}>{t('scada.solarFarm.substation.readDate')} {fecha}</div>
                            </div>
                            <div className='col' id="alerta-subestacion" style={{ position: "absolute", top: 250, left: 1050, maxWidth: "400px" }} hidden={actualizados}>
                                <div className='row' > <GoAlert size={300} color="#CED50D" /></div>
                                <div className='row justify-content-center' style={{ color: "black", fontWeight: "bold" }}> {t('scada.solarFarm.substation.message')}</div>
                            </div>
                            <div className='col' style={{ padding: 0 }}>
                                <Subestacion1 svgData={subestacion1} data={data1} />
                            </div>
                            <div className='col' style={{ padding: 0 }}>
                                <Subestacion2 svgData={subestacion2} data={data2} />
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="graficos" title={t('scada.solarFarm.substation.grafic')}>
                    <GrafSubestacion code={code} />
                </Tab>
            </Tabs>
        </div>

    )
}

export default VerSubestacion